import { Route, Routes } from 'react-router-dom';
// import CreditsPaymentScreen from '../screens/Auth/CreditsPayment';
import EmailVerificationScreen from '../screens/Auth/EmailVerification';
import HomeScreen from '../screens/Auth/Home';
import LoginScreen from '../screens/Auth/Login';
import NotFound from '../screens/Auth/NotFound';
import ResetPasswordScreen from '../screens/Auth/ResetPassword';
import TTSEnhancementScreen from '../screens/Auth/TTSEnhancement';
import ForgotPasswordScreen from '../screens/Auth/ForgotPassword';
import EntryScreen from '../screens/Auth/Entry';
import RegisterScreen from '../screens/Auth/Register';
import SuccessRegScreen from '../screens/Auth/SuccessReg';
import SmartParentsRoute from './SmartParentsRoute';

const AuthRoute: React.FC = () => {
  const isDev = process.env.NODE_ENV === 'development';
  return (
    <Routes>
      <Route
        path="/"
        element={isDev ? <HomeScreen /> : <SmartParentsRoute />}
      />
      <Route path="/start" element={<EntryScreen />} />
      <Route
        path="/register"
        element={<RegisterScreen isPhoneSignup={false} />}
      />
      {/* <Route
        path="/register-with-phone"     // todo uncomment this when endpoint is ready
        element={<RegisterScreen isPhoneSignup={true} />}
      /> */}
      {/* <Route path='/verify-phone' element={} */}
      <Route path="/register/success" element={<SuccessRegScreen />} />
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
      <Route path="/verify" element={<EmailVerificationScreen />} />
      <Route path="/reset-password" element={<ResetPasswordScreen />} />
      {/* <Route path="/credit-payment" element={<CreditsPaymentScreen />} /> */}
      <Route path="/tts-enhancement" element={<TTSEnhancementScreen />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AuthRoute;
